// extracted by mini-css-extract-plugin
export default {"page":"PageLayout_page__A84If","breadcrumbsWrapper":"PageLayout_breadcrumbsWrapper__Ge0e3","breadcrumbsWrapper_small":"PageLayout_breadcrumbsWrapper_small__5Qkz9"};